import { render, staticRenderFns } from "./PageIntroToHazards.vue?vue&type=template&id=8571f432&scoped=true&"
import script from "./PageIntroToHazards.vue?vue&type=script&lang=js&"
export * from "./PageIntroToHazards.vue?vue&type=script&lang=js&"
import style0 from "./PageIntroToHazards.vue?vue&type=style&index=0&id=8571f432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8571f432",
  null
  
)

export default component.exports